import classNames from "classnames";
import Image from "next/image";
import Heading from "../atoms/Heading";
import HeroPill from "../atoms/HeroPill";
import { SectionHeadingType } from "../atoms/SectionHeading";

export enum PriceDataType {
  Kajabi = "Kajabi",
  Graphy = "Graphy",
}

export type PricingCompareSectionPropType = {
  langFile: string;
  data: {
    type: string;
    title: SectionHeadingType;
    priceData: {
      priceType: PriceDataType;
      icon: string;
      plans: {
        planName: string;
        price: string;
        pill?: string;
      }[];
    }[];
  };
};

const PricingCompareSection = ({
  langFile,
  data,
}: PricingCompareSectionPropType) => {
  return (
    <div className="container flex flex-col items-center justify-center gap-8 sm:gap-6">
      <div className=" flex flex-col items-center justify-center gap-4 text-center">
        <Heading
          heading={data.title}
          as="h2"
          fontStyle="text-title-20 sm:text-title-32"
        />
      </div>

      <div className="grid w-full grid-cols-2 overflow-hidden rounded-3xl border border-grey-4">
        {data.priceData.map(({ priceType, icon, plans }, index) => (
          <div
            key={index}
            className={classNames(
              "flex flex-col items-center px-3 py-6 sm:px-6 ",
              {
                "bg-[#050B24] bg-primary-gradient":
                  priceType === PriceDataType.Graphy,
              },
              { "text-grey-0": priceType === PriceDataType.Graphy },
              { "text-grey-4": priceType === PriceDataType.Kajabi }
            )}
          >
            <div className="h-[36px]">
            {priceType === PriceDataType.Graphy ? (
              <Image src={icon} width={80} height={22} alt="graphy"/>
            ) : (
              <Image src={icon} width={133} height={22} alt="kajabi"/>
            )}
            </div>
            <div className="mt-6 w-full flex flex-col h-full">
              {plans.map((plan, idx) => (
                <div
                  key={idx}
                  className={classNames(
                    "m-auto flex-1 flex w-full max-w-xs items-center justify-start sm:justify-between gap-3 py-5 flex-col sm:flex-row",
                    idx !== plans.length - 1 && "border-b",
                    priceType === PriceDataType.Kajabi
                      ? "border-slate"
                      : "border-slate02"
                  )}
                >
                  <p
                    className={classNames(
                      "text-body-14 font-normal",
                      priceType === PriceDataType.Kajabi
                        ? "text-grey-4"
                        : "text-grey-0"
                    )}
                  >
                    {plan.planName}
                  </p>
                  <div className="flex items-center gap-3 flex-col sm:flex-row">
                    <p className={classNames("text-title-16 font-semibold")}>
                      {plan.price}
                    </p>
                    {plan.pill && <HeroPill category={plan.pill} />}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingCompareSection;
